// @flow

import type { Node } from "react";
import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

type Props = {
    title: Node,
    subtitle?: Node,
    children?: Node,
};

/**
 * Partners layout.
 *
 * @param props
 * @return {JSX.Element}
 * @constructor
 */
const PartnersLayout = (props: Props): React$Element<"div"> => (
    <div>
        <Row className="justify-content-between">
            <Col lg={4}>
                <h1 className={"h3 mb-0"}>{props.title}</h1>
            </Col>
            {props.subtitle ? (
                <Col lg={7}>
                    <span className="text-muted">{props.subtitle}</span>
                </Col>
            ) : (
                <></>
            )}
        </Row>
        {props.children}
    </div>
);

export default PartnersLayout;
